import { Capabilities } from '../ServerApi/types/Capabilities';
import { Permission } from './Permission';
import { Role } from './Role';

// These role names also serve as the roles' localization keys
export const PermissionRoleNames = {
  DatasourceConnector: 'datasourceConnector',
  DatasourceEditor: 'datasourceEditor',
  Editor: 'editor',
  Interactor: 'interactor',
  ProjectLeader: 'project_leader',
  Publisher: 'publisher',
  Runner: 'runner',
  Viewer: 'viewer',
};

export module PermissionTemplateRoleDefinitions {

  // Project
  const projectRoles: Role[] = [];

  const ProjectViewerAllowedCapabilities = [
    Capabilities.read
  ];
  export let ProjectViewer = Role.create(PermissionRoleNames.Viewer, ProjectViewerAllowedCapabilities, Permission.Allowed);
  projectRoles.push(ProjectViewer);

  const ProjectPublisherAllowedCapabilities = ProjectViewerAllowedCapabilities.concat([
    Capabilities.write
  ]);
  export let ProjectPublisher = Role.create(PermissionRoleNames.Publisher, ProjectPublisherAllowedCapabilities, Permission.Allowed);
  projectRoles.push(ProjectPublisher);

  const ProjectLeaderAllowedCapabilities = [
    Capabilities.projectLeader
  ];
  export let ProjectLeader = Role.create(PermissionRoleNames.ProjectLeader, ProjectLeaderAllowedCapabilities, Permission.Allowed);
  projectRoles.push(ProjectLeader);

  // Data Role
  const dataRoleRoles: Role[] = [];

  const DataRoleViewerAllowedCapabilities: string[] = [];
  export let DataRoleViewer = Role.create(PermissionRoleNames.Runner, DataRoleViewerAllowedCapabilities, Permission.Allowed);
  dataRoleRoles.push(DataRoleViewer);

  const DataRoleInteractorAllowedCapabilities = DataRoleViewerAllowedCapabilities.concat([
    Capabilities.read,
  ]);
  export let DataRoleInteractor = Role.create(PermissionRoleNames.Interactor, DataRoleInteractorAllowedCapabilities, Permission.Allowed);
  dataRoleRoles.push(DataRoleInteractor);

  const DataRoleEditorAllowedCapabilities = DataRoleInteractorAllowedCapabilities.concat([
    Capabilities.changeHierarchy,
    Capabilities.changePermissions,
    Capabilities.deleteItem,
    Capabilities.write,
  ]);
  export let DataRoleEditor = Role.create(PermissionRoleNames.Editor, DataRoleEditorAllowedCapabilities, Permission.Allowed);
  dataRoleRoles.push(DataRoleEditor);

  // Data Source
  const datasourceRoles: Role[] = [];

  const DataSourceConnectorAllowedCapabilities = [
    Capabilities.read,
    Capabilities.connect
  ];
  export let DataSourceConnector = Role.create(PermissionRoleNames.DatasourceConnector, DataSourceConnectorAllowedCapabilities, Permission.Allowed);
  datasourceRoles.push(DataSourceConnector);

  const DataSourceEditorAllowedCapabilities = DataSourceConnectorAllowedCapabilities.concat([
    Capabilities.write,
    Capabilities.deleteItem,
    Capabilities.exportXml,
    Capabilities.changePermissions,
  ]);
  export let DataSourceEditor = Role.create(PermissionRoleNames.DatasourceEditor, DataSourceEditorAllowedCapabilities, Permission.Allowed);
  datasourceRoles.push(DataSourceEditor);

  // Database
  const databaseRoles: Role[] = [];

  const DatabaseViewerAllowedCapabilities = [
    Capabilities.read,
  ];
  export let DatabaseViewer = Role.create(PermissionRoleNames.Viewer, DatabaseViewerAllowedCapabilities, Permission.Allowed);
  databaseRoles.push(DatabaseViewer);

  const DatabaseEditorAllowedCapabilities = DatabaseViewerAllowedCapabilities.concat([
    Capabilities.changePermissions,
    Capabilities.write,
  ]);
  export let DatabaseEditor = Role.create(PermissionRoleNames.Editor, DatabaseEditorAllowedCapabilities, Permission.Allowed);
  databaseRoles.push(DatabaseEditor);

  // Table
  const tableRoles: Role[] = [];

  const TableViewerAllowedCapabilities = [
    Capabilities.read,
  ];
  export let TableViewer = Role.create(PermissionRoleNames.Viewer, TableViewerAllowedCapabilities, Permission.Allowed);
  tableRoles.push(TableViewer);

  const TableEditorAllowedCapabilities = TableViewerAllowedCapabilities.concat([
    Capabilities.changePermissions,
    Capabilities.write,
  ]);
  export let TableEditor = Role.create(PermissionRoleNames.Editor, TableEditorAllowedCapabilities, Permission.Allowed);
  tableRoles.push(TableEditor);

  // Flow
  const flowRoles: Role[] = [];

  const FlowRunnerAllowedCapabilities = [
    Capabilities.execute,
    Capabilities.read,
  ];
  export let FlowRunner = Role.create(PermissionRoleNames.Runner, FlowRunnerAllowedCapabilities, Permission.Allowed);
  flowRoles.push(FlowRunner);

  const FlowEditorAllowedCapabilities = FlowRunnerAllowedCapabilities.concat([
    Capabilities.changeHierarchy,
    Capabilities.changePermissions,
    Capabilities.deleteItem,
    Capabilities.exportXml,
    Capabilities.write,
  ]);
  export let FlowEditor = Role.create(PermissionRoleNames.Editor, FlowEditorAllowedCapabilities, Permission.Allowed);
  flowRoles.push(FlowEditor);

  // Workbook
  const workbookRoles: Role[] = [];

  const WorkbookViewerAllowedCapabilities = [
    Capabilities.addComment,
    Capabilities.exportData,
    Capabilities.exportImage,
    Capabilities.read,
    Capabilities.viewComments
  ];
  export let WorkbookViewer = Role.create(PermissionRoleNames.Viewer, WorkbookViewerAllowedCapabilities, Permission.Allowed);
  workbookRoles.push(WorkbookViewer);

  const WorkbookInteractorAllowedCapabilities = WorkbookViewerAllowedCapabilities.concat([
    Capabilities.filter,
    Capabilities.shareView,
    Capabilities.vud,
    Capabilities.webAuthoring
  ]);
  export let WorkbookInteractor = Role.create(PermissionRoleNames.Interactor, WorkbookInteractorAllowedCapabilities, Permission.Allowed);
  workbookRoles.push(WorkbookInteractor);

  const WorkbookEditorAllowedCapabilities = WorkbookInteractorAllowedCapabilities.concat([
    Capabilities.changeHierarchy,
    Capabilities.changePermissions,
    Capabilities.deleteItem,
    Capabilities.exportXml,
    Capabilities.write
  ]);
  export let WorkbookEditor = Role.create(PermissionRoleNames.Editor, WorkbookEditorAllowedCapabilities, Permission.Allowed);
  workbookRoles.push(WorkbookEditor);


  // View
  const viewRoles: Role[] = [];

  const ViewViewerAllowedCapabilities = [
    Capabilities.addComment,
    Capabilities.exportData,
    Capabilities.exportImage,
    Capabilities.read,
    Capabilities.viewComments
  ];
  export let ViewViewer = Role.create(PermissionRoleNames.Viewer, ViewViewerAllowedCapabilities, Permission.Allowed);
  viewRoles.push(ViewViewer);

  const ViewInteractorAllowedCapabilities = ViewViewerAllowedCapabilities.concat([
    Capabilities.filter,
    Capabilities.shareView,
    Capabilities.vud,
    Capabilities.webAuthoring
  ]);
  export let ViewInteractor = Role.create(PermissionRoleNames.Interactor, ViewInteractorAllowedCapabilities, Permission.Allowed);
  viewRoles.push(ViewInteractor);

  const ViewEditorAllowedCapabilities = ViewInteractorAllowedCapabilities.concat([
    Capabilities.changePermissions,
    Capabilities.deleteItem
  ]);
  export let ViewEditor = Role.create(PermissionRoleNames.Editor, ViewEditorAllowedCapabilities, Permission.Allowed);
  viewRoles.push(ViewEditor);


  // All the roles get added onto this object
  export let explicitRolesByContentType: _.Dictionary<Role[]> = {
    dataRole: dataRoleRoles,
    datasource: datasourceRoles,
    flow: flowRoles,
    project: projectRoles,
    projectDataRoleTemplate: dataRoleRoles,
    projectDatasourceTemplate: datasourceRoles,
    projectFlowTemplate: flowRoles,
    projectWorkbookTemplate: workbookRoles,
    database: databaseRoles,
    databaseTableTemplate: tableRoles,
    table: tableRoles,
    view: viewRoles,
    workbook: workbookRoles,
  };

}
